// extracted by mini-css-extract-plugin
export default {"brandPromo":"rF-z","carousel":"sF-z"};